import HNSColors from "../../../../ui library/HNSColors";

import ActionButton from "./ActionButton";

export default function CancelButton({ onClick }) {
  return (
    <ActionButton
      variant="outlined"
      onClick={onClick}
      sx={{
        border: "1px solid",
        backgroundColor: HNSColors.neutrals[900],
        color: HNSColors.secondary[500],
        borderColor: HNSColors.secondary[500],
        "&:hover": {
          backgroundColor: HNSColors.secondary[900],
          color: HNSColors.secondary[500],
          borderColor: HNSColors.neutrals[900],
        },
      }}
    >
      Cancel
    </ActionButton>
  );
}
